export const removeNullAttributes = <T extends Record<string, unknown>>(
  obj: T,
): {
  [K in keyof T as T[K] extends null ? never : K]: Exclude<T[K], null>;
} => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== null),
  ) as any;
};
